//@deprecated feature - replaced by experiment.ts and statsig platform
export type FeatureFlag = {
  [key: string]: boolean
}

export type FeatureFlagResponse = Record<string, FeatureFlag>

export enum FeatureFlagValue {
  DEV = 'dev_only',
  DEMO = 'demo',

  CROSS_SELL = 'cross_sell',

  RAISE_LIMIT = 'raise_limit',

  KYC_FIRST_SCREEN = 'kyc_first_screen',
  QUIZ_KYC = 'quiz_kyc',

  PAY_INSTALLMENT_PIX = 'pay_installment_pix',

  PATH_TO_CREDIT = 'path-to-credit',
  SOFT_REGISTER = 'soft-register',

  SINGLE_PLAYER = 'single_player',
  REFUND_PENDING = 'refund_pending',

  ENABLE_MERCHANT_TERM = 'enable_merchant_term',

  // Salesperson App
  SALESPERSON_TERMS_KYC_RESEND = 'send_kyc_link_flow',
  ENABLE_ASK_INCREASE_LIMIT = 'enable-ask-increase-limit',
  IDENTITY_VALIDATION_BY_SALESPERSON = 'identity_validated_by_salesperson',

  // Supplier App
  SUPPLIER_CREDIT_ANALYSIS = 'supplier_credit_analysis',
  SUPPLIER_OPT_IN_REMOVAL = 'opt-in-removal',

  // New Experience
  NEW_EXPERIENCE = 'new-experience',
  NEW_EXPERIENCE_SALESPERSON = 'new-experience-salesperson',
  NEW_EXPERIENCE_SALESPERSON_INTELLIGENCE = 'new-experience-salesperson-intelligence',
  NEW_EXPERIENCE_SALESPERSON_STATEMENTS = 'new-experience-salesperson-statements',
  NEW_EXPERIENCE_SALESPERSON_INVOICES = 'new-experience-salesperson-invoices',
  NEW_EXPERIENCE_CREATE_ORDER = 'new-experience-create-order',

  NEW_EXPERIENCE_AUTH = 'new-experience-auth'
}

export enum FeatureConfig {
  SUPPLIER_CREDIT_ANALYSIS_POLLING = 'credit_analysis_pooling',
}

export enum FeatureFlagEmailPattern {
  UPLOAD_BUYER_EXP = '(.*\\+.*upload@tino.com.br)|(.*upload\\+partnership-qsa-as-partner-mock@email.com)|(.*upload\\+individual-qsa-as-request-mock@email.com)',
}

export enum FeatureFlagType {
  on = 'on',
  off = 'off',
}
